import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getProjectChecklist } from "../api/pfs";
import { IAPIError } from "../interfaces/common";
import { IProjectChecklistResponse } from "../interfaces/projectChecklist";

export const projectChecklistQueryKey = ['projectChecklist'] as const;

export const useProjectChecklist = (
  projectId: string,
  enabled?: boolean
): UseQueryResult<IProjectChecklistResponse, IAPIError> => {
  return useQuery<IProjectChecklistResponse, IAPIError>({
    queryKey: [...projectChecklistQueryKey, projectId],
    queryFn: ({ signal }) => getProjectChecklist(projectId, signal),
    enabled
  });
};
